import React, { useContext } from 'react';
import { Clear as ClearIcon } from '@mui/icons-material';

import { ControlWrap } from '../style';
import { SchemaDisplayContext } from '../context';
import { ROOT_NODE_TYPE } from '../../constants';

function DeleteTrigger(props) {
  const { id, topologyNodeType } = props;
  const { node: { onDelete } } = useContext(SchemaDisplayContext);

  return topologyNodeType !== ROOT_NODE_TYPE ? (
    <ControlWrap onClick={() => onDelete(id, topologyNodeType)}>
      <ClearIcon />
    </ControlWrap>
  ) : null;
}

export default DeleteTrigger;
